module.exports = __webpack_public_path__ + "images/marketing/homepage-icons.svg";